export const FAQ_MODEL = 'faq';
export const FAQ_CATEGORY_MODEL = 'faq-category';
export const ARTICLE_PAGE_MODEL = 'article';
export const ARTICLE_TAG_MODEL = 'article-tag';
export const EDITO_PAGE_MODEL = 'edito';
export const ABOUT_PAGE_MODEL = 'about';
export const BANNER_MODEL = 'banner';
export const HOME_PURPOSE_MODEL = 'home-purpose-section';
export const HOME_EXPERTISE_MODEL = 'home-expertise-section';
export const HOME_PRODUCT_CATEGORY_MODEL = 'home-product-category-section';
